var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",attrs:{"id":"indexs"}},[_c('div',{staticClass:"title"},[_vm._v("陀螺仪测试")]),_vm._v(" "),_c('div',{staticClass:"end"},[_vm._v(_vm._s(_vm.x))]),_vm._v(" "),_c('div',{staticClass:"list"},[_vm._v(_vm._s(_vm.y))]),_vm._v(" "),_c('div',{staticClass:"detail"},[_vm._v(_vm._s(_vm.z))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c9bccf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/Gy.vue
// module id = null
// module chunks = 